import { useWorkspaceFetch } from '#layers/base/public';

export async function connectRolePolicies(roleId: string, policyIds: string[]): Promise<void> {
	if (policyIds.length === 0) return;

	const fetch = useWorkspaceFetch();

	await Promise.all(
		policyIds.map((policyId) =>
			fetch(`roles/${roleId}/policies`, {
				method: 'POST',
				body: { policyId },
			}),
		),
	);
}

export async function disconnectRolePolicies(roleId: string, policyIds: string[]): Promise<void> {
	if (policyIds.length === 0) return;

	const fetch = useWorkspaceFetch();

	await Promise.all(
		policyIds.map((policyId) =>
			fetch(`roles/${roleId}/policies`, {
				method: 'DELETE',
				body: { policyId },
			}),
		),
	);
}
